import { FunctionComponent } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { createFragmentContainer, graphql } from 'react-relay';
import { Badge } from 'dibs-elements/exports/Badge';
import { useUserSessionRegions } from 'dibs-regional-info/exports/regionalInfoHelpers';
import { getIsFreeShipping } from '../../helpers/freeShippingHelpers';
import styles from './styles.scss';

import { Shipping_item as ItemProp } from './__generated__/Shipping_item.graphql';
import { Shipping_viewer as ViewerProp } from './__generated__/Shipping_viewer.graphql';

type Props = {
    item: ItemProp;
    viewer: ViewerProp | null;
};

const ShippingBadgeComponent: FunctionComponent<Props> = ({ item, viewer }) => {
    const userSessionRegions = useUserSessionRegions();
    const userRegions = userSessionRegions || viewer?.regionalInfo?.[0]?.regionsByZipCode || [];
    const isFreeRegionalShipping = getIsFreeShipping({ item, userRegions });

    if (!isFreeRegionalShipping) {
        return null;
    }

    return (
        <div className={styles.container} data-tn="free-shipping">
            <Badge type="pill" size="small-heavy">
                <FormattedMessage
                    id="dc.searchProductTile.freeShipping"
                    defaultMessage="Free Shipping"
                />
            </Badge>
        </div>
    );
};

export const ShippingBadge = createFragmentContainer(ShippingBadgeComponent, {
    viewer: graphql`
        fragment Shipping_viewer on Viewer
        @argumentDefinitions(
            fetchRegionalInfo: { type: "Boolean", defaultValue: false }
            userZipCode: { type: "String", defaultValue: "" }
            userCountryCode: { type: "String", defaultValue: "" }
        ) {
            regionalInfo(zipCode: $userZipCode, countryCode: $userCountryCode)
            @include(if: $fetchRegionalInfo) {
                regionsByZipCode {
                    displayName
                }
            }
        }
    `,
    item: graphql`
        fragment Shipping_item on Item {
            ...freeShippingHelpers_item
        }
    `,
});
